/* unplugin-vue-components disabled */import { render } from "./AuthItemDeleteDialog.vue?vue&type=template&id=d75467ca&scoped=true&ts=true"
import script from "./AuthItemDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./AuthItemDeleteDialog.vue?vue&type=script&lang=ts"

import "./AuthItemDeleteDialog.vue?vue&type=style&index=0&id=d75467ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d75467ca"]])

export default __exports__